import { IGame } from "../Interfaces";

const fireworks: IGame = {
  "name": "Fireworks",
  "author": "Yihao",
  "time": new Date("2020-08-31T12:00:00.000Z"),
  "description": "This game resembles a firework show.",
  "refreshFrequency": 4,
  "width": 19,
  "height": 19,
  "seeds": [
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      true,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ]
  ],
  "surviveRangeLower": 4,
  "surviveRangeUpper": 4,
  "reproductionRangeLower": 1,
  "reproductionRangeUpper": 1,
  "borderPolicy": "dead",
  "styles": [
    [
      {
        "size": 0,
        "color": "#eee",
        "backgroundColor": "#000000",
        "borderColor": "#000000",
        "borderRadius": 50,
        "borderWidth": 0,
        "elevation": 3
      },
      {
        "size": 0,
        "color": "#eee",
        "backgroundColor": "#000000",
        "borderColor": "#000000",
        "borderRadius": 50,
        "borderWidth": 0,
        "elevation": 3
      },
      {
        "size": 0,
        "color": "#eee",
        "backgroundColor": "#000000",
        "borderColor": "#000000",
        "borderRadius": 50,
        "borderWidth": 0,
        "elevation": 3
      },
      {
        "size": 0,
        "color": "#eee",
        "backgroundColor": "#000000",
        "borderColor": "#000000",
        "borderRadius": 50,
        "borderWidth": 0,
        "elevation": 3
      },
      {
        "size": 0,
        "color": "#eee",
        "backgroundColor": "#000000",
        "borderColor": "#000000",
        "borderRadius": 50,
        "borderWidth": 0,
        "elevation": 3
      },
      {
        "size": 0,
        "color": "#eee",
        "backgroundColor": "#000000",
        "borderColor": "#000000",
        "borderRadius": 50,
        "borderWidth": 0,
        "elevation": 3
      },
      {
        "size": 0,
        "color": "#eee",
        "backgroundColor": "#000000",
        "borderColor": "#000000",
        "borderRadius": 50,
        "borderWidth": 0,
        "elevation": 3
      },
      {
        "size": 0,
        "color": "#eee",
        "backgroundColor": "#000000",
        "borderColor": "#000000",
        "borderRadius": 50,
        "borderWidth": 0,
        "elevation": 3
      },
      {
        "size": 0,
        "color": "#eee",
        "backgroundColor": "#000000",
        "borderColor": "#000000",
        "borderRadius": 50,
        "borderWidth": 0,
        "elevation": 3
      }
    ],
    [
      {
        "size": 10,
        "color": "#fad982",
        "backgroundColor": "#000000",
        "borderColor": "rgb(62, 196, 28)",
        "borderRadius": 50,
        "borderWidth": 0,
        "elevation": 5
      },
      {
        "size": 20,
        "color": "#6bee57",
        "backgroundColor": "#000000",
        "borderColor": "rgb(74, 64, 37)",
        "borderRadius": 50,
        "borderWidth": 0,
        "elevation": 5
      },
      {
        "size": 30,
        "color": "#ce1010",
        "backgroundColor": "#000000",
        "borderColor": "rgb(80, 154, 65)",
        "borderRadius": 50,
        "borderWidth": 0,
        "elevation": 5
      },
      {
        "size": 50,
        "color": "#d91c89",
        "backgroundColor": "#000000",
        "borderColor": "rgb(209, 54, 50)",
        "borderRadius": 50,
        "borderWidth": 0,
        "elevation": 5
      },
      {
        "size": 70,
        "color": "#bdf3db",
        "backgroundColor": "#000000",
        "borderColor": "rgb(68, 80, 31)",
        "borderRadius": 50,
        "borderWidth": 0,
        "elevation": 5
      },
      {
        "size": 50,
        "color": "#141e81",
        "backgroundColor": "#000000",
        "borderColor": "rgb(199, 28, 155)",
        "borderRadius": 50,
        "borderWidth": 0,
        "elevation": 5
      },
      {
        "size": 40,
        "color": "#e662df",
        "backgroundColor": "#000000",
        "borderColor": "rgb(62, 241, 1)",
        "borderRadius": 50,
        "borderWidth": 0,
        "elevation": 5
      },
      {
        "size": 40,
        "color": "#81f6bf",
        "backgroundColor": "#000000",
        "borderColor": "rgb(144, 50, 241)",
        "borderRadius": 50,
        "borderWidth": 0,
        "elevation": 5
      },
      {
        "size": 40,
        "color": "#618ff8",
        "backgroundColor": "#000000",
        "borderColor": "rgb(183, 51, 35)",
        "borderRadius": 50,
        "borderWidth": 0,
        "elevation": 5
      }
    ]
  ]
};

export default fireworks;